import React from 'react';
import Icon from '../../../../../components/icons/Icon';
import { getDueDatePillContent } from '../assignmentUiUtils';
import { getDueReminder } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { REMINDER_VALUES } from '../../../../../../common/reminders/reminderConstants';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { useSelector } from 'react-redux';
import {
    userLocalePreferenceSelector,
    userTimeFormatPreferenceSelector,
} from '../../../../../user/currentUserSelector';
import { useTranslator } from "../../../../../components/i18n/useTranslator";

type TaskPillContentsProps = {
    element: ImMNElement;
};

const TaskPillContents = ({ element }: TaskPillContentsProps) => {
    const translate = useTranslator('elements', 'elementTypes.task');
    const dueReminder = getDueReminder(element);
    const hasReminder = dueReminder && dueReminder !== REMINDER_VALUES.NONE;

    const userLocale = useSelector(userLocalePreferenceSelector);
    const timeFormat = useSelector(userTimeFormatPreferenceSelector);

    return (
        <div>
            {hasReminder && <Icon name="reminder-bell-mini" />}
            {getDueDatePillContent(element, translate, userLocale, timeFormat)}
        </div>
    );
};

export default TaskPillContents;
